import {
  FETCH_REVIEWS,
  FETCH_REVIEW,
  SEARCH_REVIEWS,
  FETCHING_REVIEWS,
} from '../actions/types'; 

const INITIAL_STATE = {
  city:'', 
  fetching:true,
  reviews: [],
  review: null,
  offset: 0,
  limit: 10
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {

    case FETCH_REVIEWS:
      return { ...state, ...action.payload };
    case FETCH_REVIEW:
      return { ...state, review: action.payload };
    
    case SEARCH_REVIEWS:
       return { ...state,
        reviews : [...state.reviews,...action.payload.reviews].filter((o, index, arr) =>
      arr.findIndex(item => JSON.stringify(item) === JSON.stringify(o)) === index),
  
        limit:action.payload.limit,
        offset:action.payload.offset,
        count:action.payload.count,
      };
   
    case FETCHING_REVIEWS:
      return { ...state, fetching: action.payload };
    default:
      return state;
  }
};
